import { Component } from "react"
import PropTypes from "prop-types"
import { FormControl, TextField, DialogContent, DialogActions, Button } from "@mui/material"
import "./styles.scss"

export default class NewName extends Component {
  constructor(...args) {
    super(...args)
    this.state = {
      name: "",
    }
  }

  static propTypes = {
    count: PropTypes.number.isRequired,
    close: PropTypes.func,
    save: PropTypes.func.isRequired,
  }

  setName = event => {
    this.setState({ name: event.target.value })
  }

  save = () => {
    const { save, close } = this.props
    const { name } = this.state
    save(name)
    close()
  }

  render() {
    const { name } = this.state
    const { close, count } = this.props

    return <>
      <DialogContent className="modules_filter-saver_components_new-name">
        <div className="text">Create a new saved search with the {count} filters selected</div>
        <FormControl variant="standard">
          <TextField
            variant="standard"
            className="name"
            placeholder="Saved Search Name"
            value={name}
            onChange={this.setName}
            autoFocus
            slotProps={{
              htmlInput: { maxLength: 80 },
            }}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={close}>Cancel</Button>
        <Button color="primary" disabled={!name} onClick={this.save}>
          Save
        </Button>
      </DialogActions>
    </>
  }
}
